import React from 'react';
import ExperienceDetails from './experience-details';
import {CAPITA_EXP, AMDOCS_EXP, CS_EXP, TRIBBIANIS_EXP} from '../../../data/experience-summary';

const ExperienceSummary = () => {
    return (
        <section className="experience-summary">
            <h6 className="heading-small">
                <span>Experience</span>
                <small className="ml-2 tt-capital">[ 5 Years ]</small>
            </h6>

            <div className="section-content">
                <ExperienceDetails {...CAPITA_EXP}/>
                <ExperienceDetails {...AMDOCS_EXP}/>
                <ExperienceDetails {...CS_EXP}/>
                <ExperienceDetails {...TRIBBIANIS_EXP}/>
            </div>
        </section>

    );
};

export default ExperienceSummary;
